export default {
    mounted () {
        // temporary fix for prod
        // if (this.isProd() && !this.activeFrontV2) {
        //     localStorage.setItem('version', 'old')
        // }
    },
    computed: {
        activeFrontV2() {
      
            const activeAccounts = [


                '9e046e84-5b26-4c94-8379-9a88ea278490', //le divan
                '092d91e3-a47a-4b54-b36f-06299c1c4333', //collectifoups
                '09bfe424-87e9-46a0-a3d0-4d4c23a9e6b2', //lafeemaraboute
                'ab38413a-845a-4dd4-b122-cffa2b454658', //leconnecteur-biarritz
                '70465c72-23bd-4e1e-8339-78045d855f71', //handicall
                'f7c98363-9ae1-49eb-8158-8c99efe26d53', //leboulon
                'c7952eab-a5fc-482b-9aa0-eb2acb1bdcbc', //ai-facturing
                'e7271d76-8c25-4d35-9969-62bd90ff0323', //hommedumatch
                'a03617ff-2f27-4914-be3c-22a61879cad5', //mpsimmo
                'b15957bb-0983-4dcd-b807-71708fd05805', //banyuls
                '8478452f-909b-4775-a2b4-329fbd0a90ec', //cyberid
                '1ee34989-ec74-4242-94d2-c8a4623d4153', //spl-occitanie-events
                'a107edd0-c5ab-4175-935b-96ae8f7b19a1', //tse
                'f6102ca6-fd8d-41a2-8123-f9a87ffe7630', //guyotenvironnement
                'b15957bb-0983-4dcd-b807-71708fd05805', //banyuls-sur-mer
                'e172d1f7-0077-470c-b549-0be53f9ab1e8', //pellenc
                '378fff5b-2b4a-4555-8577-be21e3f4f4c1', //cyrillignac
            ];
            let user = JSON.parse(localStorage.user);
            const force = localStorage.forceBeta ? JSON.parse(localStorage.forceBeta) : false
            return activeAccounts.includes(user.account) || user.email.includes('@mashup-web.') || force;
        },
    },

    methods: {       
        switchVersion(bool) {
            if (typeof bool !== 'boolean') {
                bool = this.version !== 'beta'
            }
            
            if (bool) {
                this.version = 'beta'
                localStorage.setItem('version_', 'beta')
            } else {
                this.version = 'old'
                localStorage.setItem('version_', 'old')
            }

            this.$router.go(this.$router.currentRoute)
        },
        // temporary
        isProd() {
            return process.env.VUE_APP_API_HOST == 'https://api.saas.mashup-web.com'
        }
    },

};